import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import DeleteModal from "../../../../Layout/Components/DeleteModal";
import TipeAbsensiModal from "../components/TipeAbsensiModal";
import deleteTipeAbsensi from "../services/deleteTipeAbsensi";

const TipeAbsensiColumns = (resetState) => [
  {
    name: <DataTableTitle text={"Tipe Absensi"} />,
    selector: (row) => row.nama_tipe_absensi,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Mengurangi Cuti ?"} />,
    selector: (row) => row.mengurangi_jatah_cuti,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Perlu Persetujuan ?"} />,
    selector: (row) => row.perlu_persetujuan,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Operasi"} />,
    width: "15%",
    cell: (row) => (
      <div>
        <TipeAbsensiModal create={false} data={row} resetState={resetState} />
        &nbsp;&nbsp;
        <DeleteModal
          name={"tipe absensi"}
          axiosDelete={deleteTipeAbsensi}
          pk={row.id_tipe_absensi}
          resetState={resetState}
          isIcon
        />
      </div>
    ),
  },
];

export default TipeAbsensiColumns;
